import React from "react";

// Aba Camadas — apenas o container que o LayerManager do GrapesJS popula.

const LayersPanel = ({ active }) => {
  return (
    <div className={`v2-pane ${active ? "active" : ""}`} data-pane="layers">
      <div className="v2-pane-header">
        <div style={{ fontSize: 13, fontWeight: 600, color: "#1f2937" }}>
          <i
            className="fa fa-sitemap"
            style={{ color: "#040050", marginRight: 8 }}
          />
          Camadas do template
        </div>
      </div>
      <div className="v2-layers-host">
        <div id="layers-manager-container" />
      </div>
    </div>
  );
};

export default LayersPanel;
